import { FC, useLayoutEffect, useState } from 'react';
import Modal from 'components/Modal/Modal';
import { ImageContainer } from 'components/TrayDetails/TrayDetails.styles';
import { Image, ModalContent } from './ViewEnlargedImageModal.styles';

interface ReferenceImageGeneratorProps {
  modalOpen: boolean;
  setClosed: () => void;
  src: string;
  alt: string;
}

const STAGE_TO_WINDOW_RATIO = 0.8;

const ReferenceImageGenerator: FC<ReferenceImageGeneratorProps> = ({ modalOpen, setClosed, src, alt }) => {
  const [stageWidth, setStageWidth] = useState(window.innerWidth * STAGE_TO_WINDOW_RATIO);

  const resizeStage = () => {
    setStageWidth(window.innerWidth * STAGE_TO_WINDOW_RATIO);
  };

  useLayoutEffect(() => {
    resizeStage();
    window.addEventListener('resize', resizeStage);

    return () => window.removeEventListener('resize', resizeStage);
  }, []);

  return (
    <Modal open={modalOpen} close={() => setClosed()} PaperProps={{ sx: { maxWidth: stageWidth } }}>
      <ModalContent>
        <ImageContainer>
          <Image src={src} alt={alt} imgWidth="600px" />
        </ImageContainer>
      </ModalContent>
    </Modal>
  );
};

export default ReferenceImageGenerator;
